/** Traductions modal ajout achat (FR / AR) */
export const addPurchaseModalFr = {
  itemsAddedSuccess: '{{count}} éléments ajoutés à l\'achat',
  fillProductFields: 'Veuillez remplir tous les champs du produit',
  selectSupplier: 'Veuillez sélectionner un fournisseur',
  addAtLeastOneProduct: 'Veuillez ajouter au moins un produit à l\'achat',
  businessIdMissing: 'Identifiant entreprise introuvable — reconnectez-vous',
  savingPurchase: 'Enregistrement de l\'achat ({{count}} produit(s))...',
  purchaseCreated: 'Achat créé — {{count}} lot(s) enregistré(s)',
  saveError: 'Erreur lors de l\'enregistrement',
  title: 'Ajouter Achat',
  back: 'Retour',
  supplierRequired: 'Fournisseur *',
  newSupplierShort: '+ Fourn.',
  searchPlaceholder: 'Produit, SKU, code-barres…',
  searchMinCharsHint: 'Saisissez au moins 2 caractères…',
  searchNoResults: 'Aucun résultat — Entrée pour créer',
  newProductShort: '+ Produit',
  qtyShort: 'Qté',
  purchasePriceShort: 'P. achat',
  sellingPriceShort: 'P. vente/u',
  unitsPerCartonShort: 'U/carton',
  cartonsCountShort: 'Cartons',
  totalQtyShort: 'Qté tot.',
  packagePriceShort: 'P. carton',
  unitCostAutoShort: 'P. achat/u',
  sellUnitShort: 'P. vente/u',
  sellingPackagePriceShort: 'P. vente carton',
  addShort: 'Ajouter',
  options: 'Options',
  deliveryDate: 'Date livraison',
  datePlaceholder: 'JJ/MM/AAAA',
  location: 'Emplacement',
  mainLocation: 'Principal',
  unitsPerPackageExample: 'ex : 24',
  packagesExample: 'ex : 5',
  expiryDate: 'Date d\'Expiration',
  expiryDateShort: 'Date expiration',
  expiryDatePast: 'Impossible d\'ajouter un produit avec une date d\'expiration déjà passée',
  expiryDateRequired:
    'Date d\'expiration obligatoire pour ce produit (conservation moyenne, longue ou périssable)',
  pricePerCarton: 'Prix par carton',
  sellingPricePerCarton: 'Prix de vente par carton',
  autoFromCartonSell: 'Calculé depuis le prix carton',
  profitPerCarton: 'Profit / carton',
  autoCalculated: 'Calculé automatiquement',
  sellingPricePerUnit: 'Prix de vente par unité',
  total: 'Total',
  addToPurchase: 'Ajouter à l\'achat',
  colProduct: 'Produit',
  colQty: 'Qté',
  colPurchasePrice: 'P. achat/u',
  colSellingPrice: 'P. vente/u',
  colTotal: 'Total',
  colAction: 'Action',
  colProfit: 'Profit ligne',
  colMargin: 'Marge réelle',
  footerPotentialProfit: 'Profit potentiel',
  remove: 'Supprimer',
  productsCount: 'Articles ({{count}})',
  cancel: 'Annuler',
  createPurchase: 'Créer Achat',
  reviewPurchase: 'Vérifier l\'achat',
  reviewTitle: 'Vérification de l\'achat',
  reviewSubtitle: 'Vérifiez tous les produits avant de confirmer',
  reviewSupplier: 'Fournisseur',
  reviewDeliveryDate: 'Date de livraison',
  reviewLocation: 'Emplacement',
  reviewGrandTotal: 'Total de l\'achat',
  reviewTotalQty: 'Quantité totale',
  reviewConfirm: 'Confirmer l\'achat',
  reviewBack: 'Retour — modifier',
  addedProductsTitle: 'Produits ajoutés',
  addedProductsHint: '{{count}} produit(s) — touchez « Vérifier » pour voir la liste complète',
  noProductsYet: 'Aucun produit ajouté',
  editLine: 'Modifier',
  updateLine: 'Mettre à jour',
  cancelEditLine: 'Annuler édition',
  editingLine: 'Modification en cours',
  supplierAutoSwitched: 'Fournisseur mis à jour selon le dernier achat de ce produit',
  clickRowToEdit: 'Cliquez sur une ligne pour la modifier avant validation',
  supplierSearchPlaceholder: 'Rechercher fournisseur…',
  supplierClear: 'Effacer le fournisseur',
  supplierEmptyList: 'Aucun fournisseur — créez-en un avec + Fourn.',
  supplierNoResults: 'Aucun fournisseur correspondant',
  cashSupplierBadge: 'Comptant',
  recordedBy: 'Enregistré par',
  scanEmptyHint: 'Scannez un code-barres ou recherchez un produit — Entrée crée le produit si inconnu',
  shortcutsHint: 'F3 Fournisseur · F4 Recherche · F5 Brouillon · F6 Enregistrer · Ctrl+Entrée Valider',
  draftSaved: 'Brouillon enregistré',
  draftSavedDetail: 'Brouillon enregistré — {{count}} ligne(s)',
  draftNothingToSave: 'Rien à enregistrer dans le brouillon',
  draftSaveFailed: 'Impossible d\'enregistrer le brouillon',
  draftSavedAt: 'Brouillon enregistré à {{time}}',
  saveDraftLabel: 'Enregistrer brouillon',
  purchaseCreatedDetail: '{{id}} — {{count}} lot(s) — {{total}}',
  quickAddTitle: 'Ajout rapide produit',
  quickAddHint: 'Entrée dans la recherche crée le produit — prix sur la ligne',
  quickAddNameOnlyHint: 'Code scanné — tapez le nom puis Entrée',
  quickAddName: 'Nom',
  quickAddNamePlaceholder: 'Nom du produit',
  quickAddNameRequired: 'Saisissez le nom du produit',
  quickAddBarcode: 'Code-barres',
  quickAddCategory: 'Catégorie',
  quickAddCategoryPlaceholder: 'Choisir…',
  quickAddCategoryAuto: 'Catégorie auto · {{category}}',
  quickAddUnit: 'Unité',
  quickAddUnitsPerPack: 'U. / carton',
  quickAddSellingPack: 'P. vente carton',
  quickAddPackHint: 'Optionnel — unit, prix catalogue et carton POS',
  quickAddMoreDetails: 'Plus (catégorie, prix, carton)…',
  quickAddLessDetails: 'Masquer les détails',
  quickAddSave: 'Créer et continuer',
  quickAddCreated: '« {{name}} » créé — saisissez la quantité',
  barcodeExistsWarn: 'Ce code-barres existe déjà',
  barcodeScanned: 'Code-barres scanné',
  barcodeScanHint: 'Scanner ou coller le code',
  scanBarcodeAmbiguous:
    'Code-barres partagé par plusieurs produits — choisissez dans la liste',
  fullProductForm: 'Formulaire complet',
  fullProductFormEdit: 'Modifier le produit',
  totalUnits: '{{count}} unités',
  resumeDraft: 'Reprendre brouillon ({{count}} lignes)',
  discardDraft: 'Supprimer brouillon',
  discardDraftDone: 'Brouillon supprimé',
  roleManager: 'Manager',
  roleAdmin: 'Admin',
  unknownSupplier: 'Non spécifié',
  seedReviewTitle: 'Confirmer la ligne d\'achat',
  seedReviewProgress: 'Produit {{current}} / {{total}}',
  seedReviewStep: 'Étape achat',
  seedReviewConfirm: 'Confirmer la ligne',
  seedReviewConfirmAll: 'Confirmer tout le reste',
  seedReviewSkip: 'Passer',
  seedReviewConservation: 'Conservation',
  enterNextHint: 'Entrée → champ suivant · Entrée sur le dernier champ → confirmer',
  noExpiry: 'Sans date',
  longConservation: 'Longue',
  mediumConservation: 'Moyenne',
  perishable: 'Périssable',
};

export const addPurchaseModalAr = {
  itemsAddedSuccess: '{{count}} عنصر تم إضافته للشراء',
  fillProductFields: 'يرجى ملء جميع حقول المنتج',
  selectSupplier: 'يرجى اختيار مورد',
  addAtLeastOneProduct: 'يرجى إضافة منتج واحد على الأقل للشراء',
  businessIdMissing: 'لم يتم العثور على معرف النشاط — يرجى تسجيل الدخول مرة أخرى',
  savingPurchase: 'جاري حفظ الشراء ({{count}} منتج)...',
  purchaseCreated: 'تم إنشاء الشراء — {{count}} اللوتات مسجلة',
  saveError: 'خطأ في حفظ الشراء',
  title: 'إضافة شراء',
  back: 'رجوع',
  supplierRequired: 'المورد *',
  newSupplierShort: '+ مورد',
  searchPlaceholder: 'منتج، SKU، باركود…',
  searchMinCharsHint: 'أدخل حرفين على الأقل…',
  searchNoResults: 'لا نتائج — Enter للإنشاء',
  newProductShort: '+ منتج',
  qtyShort: 'الكمية',
  purchasePriceShort: 'س. شراء',
  sellingPriceShort: 'س. بيع/وحدة',
  unitsPerCartonShort: 'وحدة/كرتون',
  cartonsCountShort: 'كراتين',
  totalQtyShort: 'الكمية الكلية',
  packagePriceShort: 'س. الكرتون',
  unitCostAutoShort: 'س. شراء/وحدة',
  sellUnitShort: 'س. بيع/وحدة',
  sellingPackagePriceShort: 'س. بيع الكرتون',
  addShort: 'إضافة',
  options: 'خيارات',
  deliveryDate: 'تاريخ التسليم',
  datePlaceholder: 'يوم/شهر/سنة',
  location: 'الموقع',
  mainLocation: 'رئيسي',
  unitsPerPackageExample: 'مثال: 24',
  packagesExample: 'مثال: 5',
  expiryDate: 'تاريخ انتهاء الصلاحية',
  expiryDateShort: 'تاريخ انتهاء الصلاحية',
  expiryDatePast: 'لا يمكن إضافة منتج بتاريخ انتهاء صلاحية قد مضى',
  expiryDateRequired:
    'تاريخ الانتهاء إلزامي لهذا المنتج (حفظ متوسط أو طويل أو قابل للتلف)',
  pricePerCarton: 'سعر الكرتونة الواحدة',
  sellingPricePerCarton: 'سعر البيع للكرتون',
  autoFromCartonSell: 'محسوب من سعر الكرتون',
  profitPerCarton: 'ربح / كرتون',
  autoCalculated: 'محسوب تلقائياً',
  sellingPricePerUnit: 'سعر البيع لكل وحدة',
  total: 'الإجمالي',
  addToPurchase: 'إضافة للشراء',
  colProduct: 'المنتج',
  colQty: 'الكمية',
  colPurchasePrice: 'س. شراء/و',
  colSellingPrice: 'س. بيع/و',
  colTotal: 'الإجمالي',
  colAction: 'الإجراء',
  colProfit: 'ربح السطر',
  colMargin: 'الهامش الحقيقي',
  footerPotentialProfit: 'الربح المحتمل',
  remove: 'حذف',
  productsCount: 'المنتجات ({{count}})',
  cancel: 'إلغاء',
  createPurchase: 'إنشاء الشراء',
  reviewPurchase: 'مراجعة الشراء',
  reviewTitle: 'مراجعة الشراء',
  reviewSubtitle: 'تحقق من جميع المنتجات قبل التأكيد',
  reviewSupplier: 'المورد',
  reviewDeliveryDate: 'تاريخ التسليم',
  reviewLocation: 'الموقع',
  reviewGrandTotal: 'إجمالي الشراء',
  reviewTotalQty: 'الكمية الإجمالية',
  reviewConfirm: 'تأكيد الشراء',
  reviewBack: 'رجوع — تعديل',
  addedProductsTitle: 'المنتجات المضافة',
  addedProductsHint: '{{count}} منتج — اضغط « مراجعة » لعرض القائمة كاملة',
  noProductsYet: 'لم تُضف أي منتج بعد',
  editLine: 'تعديل',
  updateLine: 'تحديث',
  cancelEditLine: 'إلغاء التعديل',
  editingLine: 'جاري التعديل',
  supplierAutoSwitched: 'تم تحديث المورد حسب آخر شراء لهذا المنتج',
  clickRowToEdit: 'انقر على صف لتعديله قبل التأكيد',
  supplierSearchPlaceholder: 'بحث عن مورد…',
  supplierClear: 'مسح المورد',
  supplierEmptyList: 'لا يوجد مورد — أنشئ واحداً عبر + مورد',
  supplierNoResults: 'لا يوجد مورد مطابق',
  cashSupplierBadge: 'نقداً',
  recordedBy: 'مسجل بواسطة',
  scanEmptyHint: 'امسح الباركود أو ابحث — Enter ينشئ المنتج إن لم يوجد',
  shortcutsHint: 'F3 مورد · F4 بحث · F5 مسودة · F6 حفظ · Ctrl+Enter تأكيد',
  draftSaved: 'تم حفظ المسودة',
  draftSavedDetail: 'تم حفظ المسودة — {{count}} سطر',
  draftNothingToSave: 'لا يوجد شيء لحفظه في المسودة',
  draftSaveFailed: 'تعذر حفظ المسودة',
  draftSavedAt: 'تم حفظ المسودة في {{time}}',
  saveDraftLabel: 'حفظ المسودة',
  purchaseCreatedDetail: '{{id}} — {{count}} لوت — {{total}}',
  quickAddTitle: 'إضافة منتج سريعة',
  quickAddHint: 'Enter في البحث ينشئ المنتج — الأسعار في السطر',
  quickAddNameOnlyHint: 'تم المسح — أدخل الاسم ثم Enter',
  quickAddName: 'الاسم',
  quickAddNamePlaceholder: 'اسم المنتج',
  quickAddNameRequired: 'أدخل اسم المنتج',
  quickAddBarcode: 'الباركود',
  quickAddCategory: 'الفئة',
  quickAddCategoryPlaceholder: 'اختر…',
  quickAddCategoryAuto: 'فئة تلقائية · {{category}}',
  quickAddUnit: 'الوحدة',
  quickAddUnitsPerPack: 'وحدة / كرتون',
  quickAddSellingPack: 'س. بيع الكرتون',
  quickAddPackHint: 'اختياري — الوحدة وأسعار الكتالوج والكرتون',
  quickAddMoreDetails: 'المزيد (فئة، أسعار، كرتون)…',
  quickAddLessDetails: 'إخفاء التفاصيل',
  quickAddSave: 'إنشاء ومتابعة',
  quickAddCreated: '« {{name}} » تم إنشاؤه — أدخل الكمية',
  barcodeExistsWarn: 'هذا الباركود موجود بالفعل',
  barcodeScanned: 'تم مسح الباركود',
  barcodeScanHint: 'امسح أو الصق الرمز',
  scanBarcodeAmbiguous: 'باركود مشترك بين عدة منتجات — اختر من القائمة',
  fullProductForm: 'نموذج كامل',
  fullProductFormEdit: 'تعديل المنتج',
  totalUnits: '{{count}} وحدة',
  resumeDraft: 'متابعة المسودة ({{count}} أسطر)',
  discardDraft: 'حذف المسودة',
  discardDraftDone: 'تم حذف المسودة',
  roleManager: 'مدير',
  roleAdmin: 'مسؤول',
  unknownSupplier: 'غير محدد',
  seedReviewTitle: 'تأكيد سطر الشراء',
  seedReviewProgress: 'منتج {{current}} / {{total}}',
  seedReviewStep: 'خطوة الشراء',
  seedReviewConfirm: 'تأكيد السطر',
  seedReviewConfirmAll: 'تأكيد الباقي',
  seedReviewSkip: 'تخطّي',
  seedReviewConservation: 'الحفظ',
  enterNextHint: 'Enter → الحقل التالي · Enter في آخر حقل → تأكيد',
  noExpiry: 'بدون تاريخ',
  longConservation: 'طويل',
  mediumConservation: 'متوسط',
  perishable: 'قابل للتلف',
};
